export default __webpack_public_path__ + "static/media/miguel-lopes-38.17d19291.jpg";